export const CREATURE_EFFECT_GAIN_ARMOR = {
  copy: 'Enemy %1 gains %2 armor',
  direction: 'outbound',
};

export const CREATURE_EFFECT_GAIN_HP = {
  copy: 'Enemy %1 restores %2 HP',
  direction: 'outbound',
};

export const CREATURE_EFFECT_GAIN_MP = {
  copy: 'Enemy %1 restores %2 MP',
  direction: 'outbound',
};

export const CREATURE_EFFECT_DAMAGE = {
  copy: 'Enemy %1 hits you for %2 damage',
  direction: 'outbound',
};

export const CREATURE_EFFECT_BREAK_CREATURE_ARMOR = {
  copy: 'Enemy %1 breaks your armor',
  direction: 'outbound',
};

export const CREATURE_EFFECT_APPLY_BURN = {
  copy: 'Enemy %1 inflicts a burn on you lasting %2 turns',
  direction: 'outbound',
};

export const CREATURE_EFFECT_APPLY_FREEZE = {
  copy: 'Enemy %1 freezes your body lasting %2 turns',
  direction: 'outbound',
};

export const CREATURE_EFFECT_APPLY_PARALYSIS = {
  copy: 'Enemy %1 paralyses your body lasting %2 turns',
  direction: 'outbound',
};

export const CREATURE_EFFECT_APPLY_POISON = {
  copy: 'Enemy %1 inflicts poison on you lasting %2 turns',
  direction: 'outbound',
};
